module.exports = __webpack_public_path__ + "img/dropsSlots_320.ff24ed4c.png";